export default function SpinEvent() {
  return <></>;
}
